import React from 'react';
import '../../../styles/myclientfaq.scss';

export default function Myclientfaq(props) {
	return (
		<div>
			<div className="pl-3">
				{props?.partner?.url_path === 'c2'?"C2 Buy Before You Sell":"The Trade-In Mortgage™"} better positions you and your clients to succeed in a number of ways:
			</div>
			<br />
			<div className="how-content-myclientfaq">
				<ul className="pl-3">
					<li>
						Your client will be able to  <b>submit non-contingent offers that function like all-cash offers </b> on new home prospects, positioning them as a competitive buyer in today’s increasingly crowded real estate market.
					</li>
				</ul>
			</div>
			<div className="how-content-myclientfaq">
				<ul className="pl-3">
					<li>
						Your client will <b>buy and move into their new home before they sell their current one</b>. This will allow your client to avoid the stress of trying to time the sale of their original home with the purchase of their new home, submitting contingent offers, or moving into a short-term rental while they look for a new home.
					</li>
				</ul>
			</div>
			<div className="how-content-myclientfaq">
				<ul className="pl-3">
					<li>
						Your client can make repairs and  <b>prep their original home for sale after they have moved out</b>. This allows them to avoid the hassle of maintaining show-readiness while they live there and enables them to present their original home in the best light so you can sell it for maximum value.
					</li>
				</ul>
			</div>
			<div className="how-content-myclientfaq">
				<ul className="pl-3">
					<li>
						Your client will experience <b>cost savings</b>.  For a small convenience fee, your client will move forward with a conventional  loan on their new home while avoiding the costs of moving twice, short-term rentals, or private mortgage insurance.
					</li>
				</ul>
			</div>
		</div>
	)
}